import { useEffect, useRef } from "react";

export default function usePageReveal(key) {
  const ref = useRef(null);
  useEffect(() => {
    const root = ref.current;
    if (!root || !window.IntersectionObserver || window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const sections = root.querySelectorAll(".company-inner > *");
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-revealed");
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0, rootMargin: "0px 0px -24px 0px" });
    sections.forEach(section => {
      section.classList.add("company-reveal");
      observer.observe(section);
    });
    return () => {
      observer.disconnect();
      sections.forEach(section => section.classList.remove("company-reveal", "is-revealed"));
    };
  }, [key]);
  return ref;
}
